import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-number-updown',
  templateUrl: './custom-number-updown.component.html',
  styleUrls: ['./custom-number-updown.component.css']
})
export class CustomNumberUpdownComponent {

  @Input() value: number = 100;
  @Input() step: number = 10;
  @Input() min: number = 0;
  @Input() max: number = 9999;
  @Input() suffix: string = '%';  // so 100% works like in your screenshot

  @Output() valueChange = new EventEmitter<number>();

  increaseValue() {
    if (this.value + this.step <= this.max) {
      this.value += this.step;
      this.valueChange.emit(this.value);
    }
  }

  decreaseValue() {
    if (this.value - this.step >= this.min) {
      this.value -= this.step;
      this.valueChange.emit(this.value);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/custom-number-updown/custom-number-updown.component.ts